{
  "#HAFTRUECKLASS": {
    "TITLE": "Offene Haftrücklässe",
    "PAGES": {
      "QUERY": {
        "HEADER": "Suchen",
        "RESET": "Zurücksetzen",
        "SUBMIT": "Suche starten"
      },
      "LIST": {
        "HEADER": "Suchergebnisse",
        "QUERY": "Angewenderte Filter:",
        "FILTER": "Suchen / Filtern",
        "RESULTS": "Offene Posten",
        "NO_DATA": "Es konnten keine Daten gefunden werden"
      }
    },
    "DIALOGS": {
      "EDIT_DUE_DATE": {
        "HEADER": "Fälligkeitsdatum ändern",
        "CURRENT": "Aktuelles Fälligkeitsdatum",
        "NEW": "Neues Fälligkeitsdatum",
        "SUBMIT": "Speichern"
      }
    },
    "MENU": {
      "QUERY": "Abfrage",
      "RESULT": "Ergebnisse",
      "LOCK": "Sperren",
      "UNLOCK": "Entsperren",
      "CHANGE_DUE": "Fälligkeit ändern"
    },
    "MESSAGES": {
      "SUCCESS": {
        "CHANGED": "Der Offene Posten wurde geändert",
        "LOCKED": "Der Offene Posten wurde gesperrt",
        "UNLOCKED": "Der Offene Posten wurde entsperrt"
      },
      "QUESTIONS": {
        "LOCK": "Möchten Sie den Offenen Posten wirklich sperren?",
        "UNLOCK": "Möchten Sie den Offenen Posten wirklich entsperren?"
      },
      "ERROR": {
        "INVALID_QUERY": "Die Abfrage ist ungültig"
      },
      "WARNING": {
        "LOAD_DEFINITIONS": "Das kundenspezifische Layout konnte nicht geladen werden."
      }
    }
  }
}
